module.exports = function(ngModule) {
  ngModule.config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('about', {
      url: '/about',
      template: require('./about.html'),
      controller: require('./controller.js'),
      controllerAs: 'vm'
    });
  }]);
};
